import ViewPdfModal from './ViewPdfModal';

export default ViewPdfModal;
